import { QuestionCircleOutlined } from '@ant-design/icons';
import { Checkbox, Col, DatePicker, Row, Tooltip } from 'antd';
import moment from 'moment';
import { FC, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { SHORT_DATE_TIME_FORMAT } from '../../../utils/date';
import { StyledFormItem } from '../style';

interface Props {
  isAccountEnddateExist: boolean;
}

const AccessExpiration: FC<Props> = ({ isAccountEnddateExist }) => {
  const [checked, setChecked] = useState(isAccountEnddateExist || false);
  const intl = useIntl();
  return (
    <Row>
      <Col span={24}>
        <StyledFormItem
          label={
            <span
              onClick={() => {
                setChecked(!checked);
              }}
              role="button"
              tabIndex={-1}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  setChecked(!checked);
                }
              }}
            >
              <b className="mr-4">
                <FormattedMessage id="User.form.label.accessExpiration" />
              </b>
              <Tooltip
                placement="top"
                overlayClassName="time-tooltip"
                autoAdjustOverflow={false}
                title={<FormattedMessage id="User.form.label.time.tooltip" />}
              >
                <QuestionCircleOutlined className="grey-icon" />
              </Tooltip>
            </span>
          }
          className="mbi-0 mt-12"
        >
          <Checkbox
            checked={checked}
            onChange={e => {
              setChecked(e.target.checked);
            }}
          >
            <FormattedMessage id="User.form.label.time" />
          </Checkbox>
        </StyledFormItem>
      </Col>
      {checked && (
        <Col span={24} className="pl-24">
          <p className="mb-8">
            <FormattedMessage id="User.form.label.time.info" />
          </p>
          <StyledFormItem
            rules={[
              {
                required: true,
              },
            ]}
            name="account_end_date"
            required
            className="mbi-0"
          >
            <DatePicker
              className="w-200"
              format={SHORT_DATE_TIME_FORMAT}
              placeholder={intl.formatMessage({
                id: 'User.form.label.time.placeholder',
              })}
              disabledDate={current => current.isBefore(moment())}
              showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }}
              showNow={false}
            />
          </StyledFormItem>
        </Col>
      )}
    </Row>
  );
};

export default AccessExpiration;
